import { ApiState } from "@/store/general.types";
import { AccountState, AccountDetail, ParticipantAuthority } from "./account.types";
import { mutate } from "@/store/plugins/mutation-handler";
import { MutationTree } from "vuex";

export const accountMutations: MutationTree<AccountState> = {
    GET_ACCOUNT_MUTATION(state: AccountState, newState: ApiState<AccountDetail>) {
        mutate(state, newState, 'getAccount');
    },
    GET_PARTICIPANT_AUTHORITY(state: AccountState, newState: ApiState<ParticipantAuthority>) {
        mutate(state, newState, 'getParticipantAuthority');
    }
}
